/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './updateSubjectStatus.defs'
export { main as default } from './updateSubjectStatus.defs'
